// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"fe275ceb","315":"0a3b1c4d","330":"671603df","351":"4bd801ef","353":"b1b3381b","393":"1d850753","450":"a4044e17","476":"8c557c3f","681":"112f92db","741":"b5d2e0a7","786":"f96d5155","806":"edefaf7c","958":"1313bcbe"}[chunkId] + ".chunk.js";
};